<div class="loginContainer">
  <div class="innerContainer">
    <div *ngIf="online; else offline">
      <i [ngClass]="'app-online-welcome'" class="csx-device_wifi"></i>

      <br />
      <div style="padding-left: 18%;">
        <span class="onlineNotification">System is Online</span>
        <button type="button" class="loginbtn" (click)="login()" name="button">Login</button>
      </div>
      <br />
    </div>
    <ng-template #offline>
      <i [ngClass]="'app-offline-welcome'" class="csx-device_wifi"><span></span></i>

      <br />
      <div style="padding-left:18%;">
        <span class="onlineNotification">System is Offline</span>
        <button type="button" class="loginbtn" (click)="login()" name="button" [disabled]="!online">Login</button>
      </div>
      <br />
    </ng-template>

  </div>
</div>